import React from "react";

const SelectField = ({ fieldName, onChangeSelect, options }) => {
  return (
    <select
      className="form-select"
      onChange={onChangeSelect}
      name={fieldName}
    >
      <option value="">Recent</option>
      {options.map((item, index) => {
        return (
          <option key={index} value={item.value}>
            {item.name}
          </option>
        );
      })}
    </select>
  );
};


export {
  SelectField,
};
